import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class ControlApiConfiguration {

    server: string;

    constructor() {
        this.server = `${environment.authorityService}/api/`;
    }

    user = {
        url: 'User',
        getAll: 'User/Users',
        update: 'User/Update',
        register: 'User/Register',
        byQuery: 'User/ByQuery',
        resetPassword: 'User/ResetPassword',
        changePasswordUrl: 'User/ChangePassword',
        getUserByStaffId: 'User/UserByStaffId',
        validateUser : 'User/ValidateUser',
        getByUserName : 'User/ByUserName'
    };

    role = {
        url: 'Role',
        byQuery: 'Role/ByQuery',
        createRoleUrl: 'Role/CreateRole',
        deleteRoleUrl: 'Role/DeleteRole',
    };

    rolePermission = {
        url: 'RolePermission',
        getControlMenuPermissionsUrl: 'RolePermission/GetControlMenuPermissions',
        getRolePermissionsUrl: 'RolePermission/GetRolePermissions',
        updateRolePermissionsUrl: 'RolePermission/UpdateRolePermissions',
        userPermissions: 'RolePermission/UserPermissions',
    };

    facility = {
        url: 'Facility',
        getAll: 'Facility/Facilities',
    };

    userRole = {
        url: 'UserRole',
        userByRole: 'UserRole/UserByRole',
        add: 'UserRole/Add',
        update: 'UserRole/Update',
        delete: 'UserRole/Delete',
        getRolesByUserUrl: 'UserRole/RolesByUser'
    };

    permission = {
        url: 'Permission',
        byQuery: 'Permission/ByQuery',
    }

    passwordPolicy = {
        url: 'PasswordPolicy'
    }
}
